<template>
  <div id="import-file" class="q-pa-md">
    <div class="crud-title"><translate>AGREEMENTS_REPORT</translate></div>
    <crud ref="crudLayout" :name="name" :id="id"> </crud>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import AgreementReportController from './AgreementReportController'
import { JtCrud } from 'jtech-webcomps'
import AgreementReportPage from './AgreementReportPage'

const { CrudLayout } = JtCrud

@Component({
  name: 'AgreementReport',
  components: {
    crud: CrudLayout
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class AgreementReport extends Vue {
  controller = AgreementReportController.getInstance();

  async mounted () {
    this.onButton()
    await this.addPageImportFile()
    this.$refs.crudLayout.setPage('import')
  }

  onButton () {
    this.$refs.crudLayout.onButton('btPesquisarAgreement', this.btSearch)
  }

  get agreementData () {
    return this.agreements
  }

  async addPageImportFile () {
    const { forms, datatable } = await this.controller.loadTableAndFilters()
    if (this.$refs.crudLayout.$refs.containerRef.container.pages.length === 0) {
      this.$refs.crudLayout.addPage({
        type: 'form',
        name: 'import',
        label: this.$gettext('AGREEMENTS_REPORT'),
        labelPage: this.$gettext('AGREEMENTS_REPORT'),
        params: this.$refs.crudLayout.__loadParamsRouter({}),
        component: AgreementReportPage,
        flClose: false,
        forms: forms,
        datatable: datatable,
        controller: this.controller,
        parent: this
      })
    }
  }
}
export default AgreementReport
</script>
<style lang="stylus"></style>
